import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead } from "@/lib/seo";
import { VoorBureausPage } from "@/pages/voor-bureaus";

export const Route = createFileRoute("/$lang/pour-agences")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "fr";
    const t = i18n.getFixedT(lang, "seo");
    return pageHead({
      lang,
      pathWithoutLang: "/voor-bureaus",
      title: t("voor-bureaus.title"),
      description: t("voor-bureaus.description"),
    });
  },
  component: VoorBureausPage,
});
